 import { Environment } from '@abp/ng.core';

const baseUrl = 'https://stockmanagement-dev.upmuruguay.net';

const oAuthConfig = {
  issuer: 'https://stockmanagement-backend-dev.upmuruguay.net/',
  redirectUri: baseUrl,
  clientId: 'StockConsumableManagement_App',
  responseType: 'code',
  scope: 'offline_access StockConsumableManagement',
  requireHttps: true,
  impersonation: {
    tenantImpersonation: true,
    userImpersonation: true,
  }
};

export const environment = {
  name: 'development',
  production: false,
  application: {
    baseUrl,
    name: 'StockConsumableManagement',
  },
  oAuthConfig,
  apis: {
    default: {
      url: 'https://stockmanagement-backend-dev.upmuruguay.net',
      rootNamespace: 'Upm.StockConsumableManagement',
    },
    AbpAccountPublic: {
      url: oAuthConfig.issuer,
      rootNamespace: 'AbpAccountPublic',
    },
  },
  appVersion: '0.0.1',
} as Environment;
